import { UniformsUtils } from "three";
export var CustomMaterialName = /* @__PURE__ */ ((CustomMaterialName2) => {
  CustomMaterialName2["customDistanceMaterial"] = "customDistanceMaterial";
  CustomMaterialName2["customDepthMaterial"] = "customDepthMaterial";
  CustomMaterialName2["customDepthDOFMaterial"] = "customDepthDOFMaterial";
  return CustomMaterialName2;
})(CustomMaterialName || {});
import {
  assignUniformViaUserData,
  copyOnBeforeCompileData
} from "../../engine/nodes/gl/code/assemblers/materials/OnBeforeCompile";
const RENDER_HOOK_USER_DATA_KEY = "POLY_render_hook";
const EMPTY_RENDER_HOOK = (renderer, scene, camera, geometry, material, group) => {
};
export class CoreMaterial {
  static node(scene, material) {
    return scene.node(material.name);
  }
  static clone(scene, srcMaterial, options) {
    const clonedMaterial = srcMaterial.clone();
    const srcUniforms = srcMaterial.uniforms;
    if (srcUniforms) {
      clonedMaterial.uniforms = UniformsUtils.clone(srcUniforms);
    }
    copyOnBeforeCompileData(scene, {
      src: srcMaterial,
      dest: clonedMaterial,
      shareCustomUniforms: options.shareCustomUniforms
    });
    return clonedMaterial;
  }
  static add_user_data_render_hook(material, render_hook) {
    material.userData[RENDER_HOOK_USER_DATA_KEY] = render_hook;
  }
  static apply_render_hook(object, material) {
    if (material.userData) {
      const render_hook = material.userData[RENDER_HOOK_USER_DATA_KEY];
      if (render_hook) {
        object.onBeforeRender = (renderer, scene, camera, geometry, material2, group) => {
          render_hook(renderer, scene, camera, geometry, material2, group, object);
        };
        return;
      }
    }
    object.onBeforeRender = EMPTY_RENDER_HOOK;
  }
  static applyCustomMaterials(object, material) {
    const material_with_custom = material;
    if (material_with_custom.customMaterials) {
      for (let name of Object.keys(material_with_custom.customMaterials)) {
        const mat_name = name;
        const custom_material = material_with_custom.customMaterials[mat_name];
        if (custom_material) {
          object[mat_name] = custom_material;
          custom_material.needsUpdate = true;
        }
      }
    }
  }
  static assignUniforms(mat, uniformName, uniform, assembler) {
    assignUniformViaUserData(mat, uniformName, uniform);
    if (assembler) {
      this.assignUniformForOnBeforeCompile(mat, uniformName, uniform, assembler);
    }
  }
  static assignUniformForOnBeforeCompile(mat, uniformName, uniform, assembler) {
    assembler.addAdditionalTextureUniforms(uniformName, uniform);
  }
}
